import { useSelector } from "react-redux"
import BackToTop from "../components/backToTop"
import BtnLink from "../components/campusLife/BtnLink"
import Heading from "../components/heading"
import { retrunAssets } from "../utils/getAssets"
import { DecodeHtml } from "../utils/decodeHtml"

const NeedTechnicalSupport = () => {


    const state = useSelector(state => state.campusLifeTab)
    const wifiAndConnectivity = state?.data?.properties
    const systemSecurityPoliciesSteps = wifiAndConnectivity?.systemSecurityPoliciesSteps?.items?.map(item => {
        let step = item?.content?.properties
        return {
            label: step?.label,
            link: step?.link
        }
    })
    const technicalSupportImage = wifiAndConnectivity?.technicalSupportImage !== null ? retrunAssets(wifiAndConnectivity?.technicalSupportImage[0].url) : ""
    const unitenHelpdeskDescription = DecodeHtml({ html: wifiAndConnectivity?.unitenHelpdeskDescription?.markup })
    const iTMSHelpdeskDescription = DecodeHtml({ html: wifiAndConnectivity?.iTMSHelpdeskDescription?.markup })
    


    // const labImage = `https://www.uniten.edu.my/media/1924/student-life-49-it-labs-kshas.jpg`
    return (
        <div className="flex flex-col items-center w-full gap-5 py-8 ">
            <div className="grid grid-cols-1 md:grid-cols-2 place-items-start items-end gap-16 w-full">
                <h1 className="w-auto  text-slate-900 text-4xl font-bold  capitalize">Need help on technical support ?</h1>
                <div className="flex flex-col gap-2">
                    <p className="w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal  leading-normal">{`Click here for`}</p>
                    <div className="flex flex-col gap-5">
                        {
                            systemSecurityPoliciesSteps?.map((step, index) => (
                                <BtnLink key={index} text={step?.label} file={step?.link} />
                            ))
                        }


                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
                <div className="w-full h-[30rem] bg-cover bg-center bg-no-repeat bg-gray-200" style={{ backgroundImage: `url('${technicalSupportImage}')` }}></div>
                <div className="flex flex-col flex-1 gap-5">
                    <Heading name="SERVICE REQUEST" color="text-blue-700" />
                    <div className="flex flex-col gap-2">
                        <h1 className="w-auto  text-slate-900 text-4xl font-bold  uppercase">UNITEN Helpdesk : </h1>
                        <p className="w-auto flex-1 self-stretch bg-blue-100 p-4  text-justify text-sky-950 text-opacity-70 text-base font-normal  leading-normal">{unitenHelpdeskDescription}</p>

                    </div>
                    <div className="flex flex-col gap-2">
                        <h1 className="w-auto  text-slate-900 text-4xl font-bold  uppercase">ITMS HELPDESK :  </h1>
                        <p className="w-auto flex-1 self-stretch bg-blue-100 p-4  text-justify text-sky-950 text-opacity-70 text-base font-normal flex flex-col gap-3 leading-normal">{iTMSHelpdeskDescription}<span className="font-bold">ITMS Helpdesk+603-8921 2020 ext 1669</span></p>

                    </div>

                </div>
            </div>
            <BackToTop />

        </div>
    )
}

export default NeedTechnicalSupport